import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../../types"
import { CustomTextConfig } from "./custom-text.interface"
import {
  BackgroundWrapper,
  SectionArticle,
  SectionHeading,
  SectionLayout,
} from "../../section.component"
import { SectionContainer } from "../../../../../resolvers/text/text.resolver"

type CustomTextProps = {
  config: CustomTextConfig
}

const CustomTextContainer = styled(SectionContainer)`
  width: 100%;
  padding: 0 0px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 0 0px;
  }

  ${SectionHeading} {
    width: 100%;
    max-width: 100%;
    margin-bottom: 32px;

    h2 {
      width: 100%;
      text-align: left !important;

      /* Heading/H2 */
      font-family: Facto;
      font-size: 23px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%; /* 27.6px */
      margin: 0;

      @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
        font-family: Facto;
        font-size: 23px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
      }
    }
  }
`

const CustomTextArticle = styled(SectionArticle)`
  max-width: 100%;
  text-align: left;

  p {
    font-family: ${({ theme }) => theme.font.basic};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    margin: 0 0 24px 0;
    color: #000;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

const Divider = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background-color: #000;
  margin: 32px 0 0 0;
`

const CustomText: AppFunctionComponent<CustomTextProps> = ({ config }) => {
  return (
    <BackgroundWrapper background={config.customText.background}>
      <CustomTextContainer layout={SectionLayout.TextLeftAligned}>
        <SectionHeading style={{ textAlign: "left" }}>
          <h2>{config.customText.heading}</h2>
        </SectionHeading>

        <CustomTextArticle>
          {config.customText.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </CustomTextArticle>

        {config.customText.showDivider && <Divider />}
      </CustomTextContainer>
    </BackgroundWrapper>
  )
}

export default CustomText
